import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import './GettingStarted.css';
import {
  FaBox,
  FaPuzzlePiece,
  FaRocket,
  FaExchangeAlt,
  FaLock,
  FaNetworkWired,
  FaSwatchbook,
  FaGlobe,
  FaFileAlt,
  FaCubes,
  FaCube,
  FaDiceD6,
} from 'react-icons/fa';

const SolutionCard = ({ icon, title, description, status, link, linkText }) => {
  return (
    <div className={`solution-card ${status}`}>
      {status && <div className="status-badge">{status}</div>}
      <div className="solution-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
      {status === 'Live' && link && (
        <a href={link} className="btn btn-primary solution-button mt-3">
          {linkText}
        </a>
      )}
    </div>
  );
};

SolutionCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  status: PropTypes.string,
  link: PropTypes.string,
  linkText: PropTypes.string,
};

export default function Solutions() {
  return (
    <section className="solutions-section" id="solutions">
      <Container>
        <div className="section-header">
          <h2 className="section-title">Utility/Solutions</h2>
          <p className="section-description">
            Powerful blockchain solutions built for the real world
          </p>
        </div>

        <Row className="solution-grid">
          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaBox />}
              title="Onchain Stable Asset Tokenization"
              description="Convert stable assets like USDT into digital tokens on the blockchain. With our MCGP Backup solution, users can tokenize funds to earn daily returns/RoS, receive up to 30% in referral bonuses, and enjoy secure storage through smart contracts."
              status="Live"
              link="https://backup.mcgpchain.com/"
              linkText="Tokenize Now"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaPuzzlePiece />}
              title="Web3 Mining"
              description="This allows users to connect, interact and earn rewards in MCGP native asset through data validation, social engagement, and providing resources which fosters web3 adoption and decentralization."
              status="Live"
              link="https://mining.mcgpchain.com/"
              linkText="Join Now"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaRocket />}
              title="ICO / IEO Rounds"
              description="Participate in early funding rounds to purchase $MCGP tokens at discounted rates before they become publicly available on exchanges."
              status="Live"
              link="/presale"
              linkText="Buy Presale"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaExchangeAlt />}
              title="Live Trading and CEx/DEx Listing"
              description="Buy and sell $MCGP tokens in real-time on both centralized (CEX) and decentralized (DEX) exchanges post-launch."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaLock />}
              title="Staking"
              description="Lock your $MCGP tokens in our MCGPchain ecosystem to support operations/innovation and earn passive income or rewards."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaNetworkWired />}
              title="Tsa Connect"
              description="A gateway or platform connecting users to TSA-enabled services like token sales, staking, trading of local product & services and asset management."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaFileAlt />}
              title="Token Launcher"
              description="Create your own cryptocurrency in minutes—no coding skills required."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaRocket />}
              title="Token Launchpad"
              description="Launch and distribute tokens for your crypto projects to early backers and investors quickly and efficiently."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaCubes />}
              title="RWA Tokenization Module"
              description="Easily tokenize your real-world assets for increased liquidity, secure ownership, and seamless trading."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaDiceD6 />}
              title="NFT & AI Marketplace"
              description="Buy, sell, and trade AI-generated or AI-enhanced NFTs—where creativity meets technology."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaCube />}
              title="MCGP Network Chain"
              description="A scalable blockchain infrastructure powering decentralized apps and digital assets within our ecosystem."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaSwatchbook />}
              title="Easy Swap"
              description="A user-friendly tool for instantly exchanging cryptocurrencies across multiple blockchains."
              status="Coming Soon"
            />
          </Col>

          <Col lg="4" md="6" sm="12" className="mb-4">
            <SolutionCard
              icon={<FaGlobe />}
              title="Metaverse & Play2Earn"
              description="Dive into immersive virtual worlds and earn rewards by playing games and engaging in digital experiences."
              status="Coming Soon"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
